import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// En-tête de section réutilisable : eyebrow orange, titre H2, sous-titre, lien « voir tout » optionnel.
export default function SectionHeader({ eyebrow, title, subtitle, linkTo, linkLabel, linkTestId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="text-[11px] font-bold uppercase tracking-widest text-[#E05638]">{eyebrow}</div>
        )}
        <h2 className="mt-1 font-heading text-2xl lg:text-3xl font-extrabold tracking-tight text-[#172A3A]">{title}</h2>
        {subtitle && <p className="mt-1.5 text-sm md:text-base text-[#66727A] leading-relaxed">{subtitle}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          data-testid={linkTestId}
          className="shrink-0 inline-flex items-center gap-1 text-sm font-bold text-[#E05638] hover:gap-1.5 transition-all"
        >
          {linkLabel || "Tout voir"} <ArrowRight size={15} />
        </Link>
      )}
    </div>
  );
}
